<template>
  <drag-modal :visible="visible"
              :loading="loading"
              width="4.5rem"
              @cancel="() => (visible = false)">
    <div class="flex-row justify-between align-center"
         slot="title">
      <div class="flex-row flex-1">
        <span class="font-bold trans-o-left"
              style="transform: scale(0.931944); font-size: 14px">{{ title }}{{ queryParam.Name }}</span>
      </div>
      <div>
        <!-- <span style="
            padding-right: 13.9792px;
            padding-left: 13.9792px;
            display: inline-block;
            transform: scale(0.815451);
            font-size: 14px;
          ">
          今日报警 <span class="font-bold">{{ alarmCount }}</span> 次</span> -->
      </div>
    </div>
    <div>
      <div class="flex-column center"
           style="font-size: 9.78542px">
        <span v-if="data.WorkingType == 2"
              style="color: green">(下降)</span>
        <span v-else-if="data.WorkingType == 1"
              style="color: green">(上升)</span>
        <span v-else
              style="color: red">(未运行)</span>
        <div style="float: right">采集时间：{{ data.LastDateTimeText }}</div>
      </div>
    </div>
    <div class="flex-column center"
         style="margin-top: 18.1729px">
      <ul class="clearfix device-list flex-wrap">
        <li class="flex-row"
            style="
            margin-top: 13.9792px;
            padding-left: 13.9792px;
            width: 122.318px;
          ">
          <span class="
              item-circle
              zhgd_iconfont zhgd_icon-tadiaogou
              flex-row
              center
            "
                style="
              width: 29.3562px;
              height: 29.3562px;
              margin-right: 6.98958px;
              transform: scale(1);
              font-size: 18.1729px;
            "></span>
          <div class="flex-column">
            <span class="trans-o-left"
                  style="transform: scale(0.815451); font-size: 9.78542px">重量</span>
            <span class="flex-row"><span class="font-bold trans-o-left"
                    style="transform: scale(0.931944); font-size: 11.1833px">{{ data.RealtimeWeight }}</span>
              <span class="trans-o-left"
                    style="transform: scale(0.815451); font-size: 9.78542px">t</span></span>
          </div>
        </li>
        <li class="flex-row"
            style="
            margin-top: 13.9792px;
            padding-left: 13.9792px;
            width: 122.318px;
          ">
          <span class="item-circle zhgd_iconfont zhgd_icon-fudu flex-row center"
                style="
              width: 29.3562px;
              height: 29.3562px;
              margin-right: 6.98958px;
              transform: scale(1);
              font-size: 18.1729px;
            "></span>
          <div class="flex-column">
            <span class="trans-o-left"
                  style="transform: scale(0.815451); font-size: 9.78542px">高度</span>
            <span class="flex-row"><span class="font-bold trans-o-left"
                    style="transform: scale(0.931944); font-size: 11.1833px">{{ data.RealtimeHeight }}</span>
              <span class="trans-o-left"
                    style="transform: scale(0.815451); font-size: 9.78542px">m</span></span>
          </div>
        </li>
        <li class="flex-row"
            style="
            margin-top: 13.9792px;
            padding-left: 13.9792px;
            width: 122.318px;
          ">
          <span class="item-circle zhgd_iconfont zhgd_icon-gaodu flex-row center"
                style="
              width: 29.3562px;
              height: 29.3562px;
              margin-right: 6.98958px;
              transform: scale(1);
              font-size: 18.1729px;
            "></span>
          <div class="flex-column">
            <span class="trans-o-left"
                  style="transform: scale(0.815451); font-size: 9.78542px">人数</span>
            <span class="flex-row"><span class="font-bold trans-o-left"
                    style="transform: scale(0.931944); font-size: 11.1833px">{{ data.RealtimePeople }}</span>
              <span class="trans-o-left"
                    style="transform: scale(0.815451); font-size: 9.78542px">人</span></span>
          </div>
        </li>
        <li class="flex-row"
            style="
            margin-top: 13.9792px;
            padding-left: 13.9792px;
            width: 122.318px;
          ">
          <span class="item-circle zhgd_iconfont zhgd_icon-huizhuan flex-row center"
                style="
              width: 29.3562px;
              height: 29.3562px;
              margin-right: 6.98958px;
              transform: scale(1);
              font-size: 18.1729px;
            "></span>
          <div class="flex-column">
            <span class="trans-o-left"
                  style="transform: scale(0.815451); font-size: 9.78542px">楼层</span>
            <span class="flex-row"><span class="font-bold trans-o-left"
                    style="transform: scale(0.931944); font-size: 11.1833px">{{ data.RealtimeFloor }}</span>
              <span class="trans-o-left"
                    style="transform: scale(0.815451); font-size: 9.78542px">楼</span></span>
          </div>
        </li>
        <li class="flex-row"
            style="
            margin-top: 13.9792px;
            padding-left: 13.9792px;
            width: 122.318px;
          ">
          <span class="item-circle zhgd_iconfont zhgd_icon-feng flex-row center"
                style="
              width: 29.3562px;
              height: 29.3562px;
              margin-right: 6.98958px;
              transform: scale(1);
              font-size: 18.1729px;
            "></span>
          <div class="flex-column">
            <span class="trans-o-left"
                  style="transform: scale(0.815451); font-size: 9.78542px">风速</span>
            <span class="flex-row"><span class="font-bold trans-o-left"
                    style="transform: scale(0.931944); font-size: 11.1833px">{{ data.RealtimeWindSpeed }}</span>
              <span class="trans-o-left"
                    style="transform: scale(0.815451); font-size: 9.78542px">m/s</span></span>
          </div>
        </li>
        <li class="flex-row"
            style="
            margin-top: 13.9792px;
            padding-left: 13.9792px;
            width: 122.318px;
          ">
          <span class="item-circle zhgd_iconfont zhgd_icon-qingjiao flex-row center"
                style="
              width: 29.3562px;
              height: 29.3562px;
              margin-right: 6.98958px;
              transform: scale(1);
              font-size: 18.1729px;
            "></span>
          <div class="flex-column">
            <span class="trans-o-left"
                  style="transform: scale(0.815451); font-size: 9.78542px">风级</span>
            <span class="flex-row"><span class="trans-o-left"
                    style="transform: scale(0.815451); font-size: 9.78542px"></span>
              <span class="font-bold trans-o-left"
                    style="
                  padding-left: 3.49479px;
                  transform: scale(0.931944);
                  font-size: 11.1833px;
                ">{{ data.RealtimeWindLevel }}</span>
              <span class="trans-o-left"
                    style="transform: scale(0.815451); font-size: 9.78542px">级</span></span>
          </div>
        </li>
        <li class="flex-row"
            style="
            margin-top: 13.9792px;
            padding-left: 13.9792px;
            width: 122.318px;
          ">
          <span class="item-circle zhgd_iconfont zhgd_icon-feng flex-row center"
                style="
              width: 29.3562px;
              height: 29.3562px;
              margin-right: 6.98958px;
              transform: scale(1);
              font-size: 18.1729px;
            "></span>
          <div class="flex-column">
            <span class="trans-o-left"
                  style="transform: scale(0.815451); font-size: 9.78542px">X倾角</span>
            <span class="flex-row"><span class="font-bold trans-o-left"
                    style="transform: scale(0.931944); font-size: 11.1833px">{{ data.RealtimeDipX }}</span>
              <span class="trans-o-left"
                    style="transform: scale(0.815451); font-size: 9.78542px">m/s</span></span>
          </div>
        </li>
        <li class="flex-row"
            style="
            margin-top: 13.9792px;
            padding-left: 13.9792px;
            width: 122.318px;
          ">
          <span class="item-circle zhgd_iconfont zhgd_icon-qingjiao flex-row center"
                style="
              width: 29.3562px;
              height: 29.3562px;
              margin-right: 6.98958px;
              transform: scale(1);
              font-size: 18.1729px;
            "></span>
          <div class="flex-column">
            <span class="trans-o-left"
                  style="transform: scale(0.815451); font-size: 9.78542px">Y倾角</span>
            <span class="flex-row"><span class="trans-o-left"
                    style="transform: scale(0.815451); font-size: 9.78542px"></span>
              <span class="font-bold trans-o-left"
                    style="
                  padding-left: 3.49479px;
                  transform: scale(0.931944);
                  font-size: 11.1833px;
                ">{{ data.RealtimeDipY }}</span>
              <span class="trans-o-left"
                    style="transform: scale(0.815451); font-size: 9.78542px">°</span></span>
          </div>
        </li>
      </ul>
    </div>
  </drag-modal>
</template>
<script>
import DragModal from "@/components/DragModal";
export default {
  data () {
    return {
      loading: true,
      visible: false,
      title: "",
      queryParam: {},
      alarmCount: 0,
      data: {},
    };
  },
  components: {
    DragModal,
  },
  methods: {
    openForm (device) {
      console.log(device);
      this.title = device.DeviceMethodStr;
      this.queryParam = { ProId: device.ProId, DeviceId: device.Id };
      this.loading = false;
      this.visible = true;
      this.init();
    },
    init () {
      console.log(this.queryParam);
      this.loading = true;
      this.$http
        .post("/DeviceManage/DeviceElevator/GetFullRecordDataList", {
          PageIndex: 1,
          PageRows: 1,
          SortField: "RecordDate",
          SortType: "DESC",
          Search: this.queryParam,
        })
        .then((resJson) => {
          this.loading = false;
          if (resJson.Data && resJson.Data.length == 1)
            this.data = resJson.Data[0];
          else this.data = {};
        });
    },
  },
};
</script>
<style scoped>
.align-center {
  align-items: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  text-align: center;
}
.device-list li {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
}
</style>